import React, { useMemo } from 'react';
//interfaces
import { PremiumProduct } from '../interfaces/PremiumProduct';

//utils
import styles from './premiumBundle.module.scss';
import SVG from 'react-inlinesvg';
//assets
import discountSticker from '../../shared/assets/label.svg';

//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

/* Providers */
import { useShopContext } from '../../shared/__providers__/ShopContext';
import { PremiumShop } from '../PremiumShop';

export interface PremiumBundleProps {
  product: PremiumProduct;
}
export const PremiumBundle: React.FC<PremiumBundleProps> = ({ product }) => {
  const { t } = useTranslation();
  const { shop } = useShopContext();
  const premiumShop = shop as PremiumShop;
  const hasDiscount = product.discountPercentage !== 0;

  const isSelected = useMemo(
    () => premiumShop!.selectedProduct.plan.id === product.plan.id,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [premiumShop && premiumShop.selectedProduct],
  );

  return (
    <div
      className={styles.bundle}
      id={isSelected ? styles.selectedBundle : styles.unselectedBundle}
    >
      {hasDiscount && (
        <div className={styles.discountSticker}>
          <SVG src={discountSticker} />
          <h3>-{product.discountPercentage}%</h3>
        </div>
      )}

      <h1 className={styles.daysCode}>{tr(t, product.template.code)}</h1>
      <div className={styles.prices}>
        <div>
          {hasDiscount && (
            <h3 className={styles.previousPrice}>
              {product.price.buildPrice().toString()}
            </h3>
          )}
          <h3
            className={
              hasDiscount ? styles.promotedPrice : styles.unPromotedPrice
            }
          >
            {product.priceWithDiscount.buildPrice().toString()}
          </h3>
        </div>

        <div className={styles.radioBtn}> </div>
      </div>
    </div>
  );
};
